import { useContext, useEffect } from 'react'
import {
  GlobalDataContext,
  TemplateContext,
  evaluateTemplateValue,
  propsDataLocationToPathAndValue,
} from '@ea-lab/reactive-json'

/**
 * Generic "serialize to JSON" bridge. Keeps `target` (a store path) in sync with
 * `JSON.stringify(source)` whenever `source` changes. Renders nothing.
 *
 * Reactive-json reactions can't stringify, so a value edited as structured data
 * (e.g. a widgets array) can't be POSTed to a plain string field. This mirror
 * maintains a string copy that a `submitData` can send. Fully generic —
 * reusable anywhere a store array/object must round-trip through a text field.
 *
 * YAML :
 *   - type: JsonMirror
 *     source: ~~.currentDash.widgets     # structured value (array/object)
 *     target: ~~.currentDash.layoutStr   # store path receiving the JSON string
 */
export const JsonMirror = ({ props, path, datafield }) => {
  const globalDataContext = useContext(GlobalDataContext)
  const templateContext = useContext(TemplateContext)

  const source = evaluateTemplateValue({
    valueToEvaluate: props.source,
    globalDataContext,
    templateContext,
  })
  const { formDataPath } = propsDataLocationToPathAndValue({
    currentPath: path,
    datafield,
    dataLocation: props.target,
    defaultValue: '',
    globalDataContext,
    templateContext,
  })

  const serialized = source === undefined ? '' : JSON.stringify(source)

  useEffect(() => {
    globalDataContext.updateData(serialized, formDataPath)
  }, [serialized, formDataPath])

  return null
}
